/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TextBookCreateForm model module.
   * @module textbook/model/TextBookCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookCreateForm</code>.
   * @alias module:textbook/model/TextBookCreateForm
   * @class
   * @param title {String} 书名
   */
  var exports = function(title) {
    var _this = this;



    _this['title'] = title;





















  };

  /**
   * Constructs a <code>TextBookCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookCreateForm} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookCreateForm} The populated <code>TextBookCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'bookType')) {
        obj['bookType'] = ApiClient.convertToType(data['bookType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bookFormat')) {
        obj['bookFormat'] = ApiClient.convertToType(data['bookFormat'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUri')) {
        obj['thumbUri'] = ApiClient.convertToType(data['thumbUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cardBgUri')) {
        obj['cardBgUri'] = ApiClient.convertToType(data['cardBgUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'note')) {
        obj['note'] = ApiClient.convertToType(data['note'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'content')) {
        obj['content'] = ApiClient.convertToType(data['content'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'isbn')) {
        obj['isbn'] = ApiClient.convertToType(data['isbn'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'authors')) {
        obj['authors'] = ApiClient.convertToType(data['authors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompanyId')) {
        obj['publisherCompanyId'] = ApiClient.convertToType(data['publisherCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publishers')) {
        obj['publishers'] = ApiClient.convertToType(data['publishers'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'issuedDate')) {
        obj['issuedDate'] = ApiClient.convertToType(data['issuedDate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'aiTextbook')) {
        obj['aiTextbook'] = ApiClient.convertToType(data['aiTextbook'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'standardType')) {
        obj['standardType'] = ApiClient.convertToType(data['standardType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'chiefEditor')) {
        obj['chiefEditor'] = ApiClient.convertToType(data['chiefEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'deputyEditor')) {
        obj['deputyEditor'] = ApiClient.convertToType(data['deputyEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contributingAuthors')) {
        obj['contributingAuthors'] = ApiClient.convertToType(data['contributingAuthors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producer')) {
        obj['producer'] = ApiClient.convertToType(data['producer'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contactInfo')) {
        obj['contactInfo'] = ApiClient.convertToType(data['contactInfo'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'edition')) {
        obj['edition'] = ApiClient.convertToType(data['edition'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduStage')) {
        obj['eduStage'] = ApiClient.convertToType(data['eduStage'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'copyrightStatement')) {
        obj['copyrightStatement'] = ApiClient.convertToType(data['copyrightStatement'], 'String');
      }
    }
    return obj;
  }

  /**
   * 书籍类型 1:数字教材 2:电子书
   * @member {Integer} bookType
   */
  exports.prototype['bookType'] = undefined;
  /**
   * 电子书格式 0:App 100:自建H5 101:第三方H5 200:pdf
   * @member {Integer} bookFormat
   */
  exports.prototype['bookFormat'] = undefined;
  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 封面uri 上传时使用
   * @member {String} thumbUri
   */
  exports.prototype['thumbUri'] = undefined;
  /**
   * 卡片背景图uri 上传时使用
   * @member {String} cardBgUri
   */
  exports.prototype['cardBgUri'] = undefined;
  /**
   * 简介
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 后台备注
   * @member {String} note
   */
  exports.prototype['note'] = undefined;
  /**
   * 课程详情模板
   * @member {String} content
   */
  exports.prototype['content'] = undefined;
  /**
   * ISBN号
   * @member {String} isbn
   */
  exports.prototype['isbn'] = undefined;
  /**
   * 作者名，逗号分隔
   * @member {String} authors
   */
  exports.prototype['authors'] = undefined;
  /**
   * 出版社id
   * @member {Integer} publisherCompanyId
   */
  exports.prototype['publisherCompanyId'] = undefined;
  /**
   * 出版社，逗号分隔
   * @member {String} publishers
   */
  exports.prototype['publishers'] = undefined;
  /**
   * 实体书发布时间
   * @member {Date} issuedDate
   */
  exports.prototype['issuedDate'] = undefined;
  /**
   * 价格 单位分
   * @member {Integer} price
   */
  exports.prototype['price'] = undefined;
  /**
   * 是否AI教材
   * @member {Boolean} aiTextbook
   */
  exports.prototype['aiTextbook'] = undefined;
  /**
   * 规划教材类型 0:无 1:国规 2:省规
   * @member {Integer} standardType
   */
  exports.prototype['standardType'] = undefined;
  /**
   * 主编
   * @member {String} chiefEditor
   */
  exports.prototype['chiefEditor'] = undefined;
  /**
   * 副主编
   * @member {String} deputyEditor
   */
  exports.prototype['deputyEditor'] = undefined;
  /**
   * 参编人员
   * @member {String} contributingAuthors
   */
  exports.prototype['contributingAuthors'] = undefined;
  /**
   * 制作单位
   * @member {String} producer
   */
  exports.prototype['producer'] = undefined;
  /**
   * 教材联系
   * @member {String} contactInfo
   */
  exports.prototype['contactInfo'] = undefined;
  /**
   * 版次
   * @member {String} edition
   */
  exports.prototype['edition'] = undefined;
  /**
   * 1中职，2高职，3 中高职
   * @member {Integer} eduStage
   */
  exports.prototype['eduStage'] = undefined;
  /**
   * 版权声明
   * @member {String} copyrightStatement
   */
  exports.prototype['copyrightStatement'] = undefined;



  export default exports;
;


